module.exports.DEFAULT_REVIEWS_FILTER = 'relevant';
